import { useLocation } from "react-router-dom";

export const useIsClassroom = () => {
  const isClassroom = useLocation().pathname.includes("/classroom/");

  return { isClassroom };
};
